(function () {
  function initQuickViewPopup() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view-trigger]');
      if (trigger) {
        e.preventDefault();
        var card = trigger.closest('product-card');
        if (!card) return;
        var popup = card.querySelector('[data-quick-view-popup]');
        if (popup) {
          popup._quickViewCard = card;
          document.body.appendChild(popup);
          popup.removeAttribute('hidden');
          popup.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              initSwiperInPopup(popup);
            });
          });
        }
        return;
      }

      var closeTrigger = e.target.closest('.quick-bg-js, .close-btn-js');
      if (closeTrigger) {
        var wrapper = closeTrigger.closest('.quick-view-popup');
        if (wrapper) {
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.setAttribute('hidden', '');
          document.body.style.overflow = '';
          var card = wrapper._quickViewCard;
          if (card && wrapper.parentNode === document.body) {
            card.appendChild(wrapper);
          }
        }
        return;
      }

      if (e.target.closest('.read-more-button-js')) {
        var desc = e.target.closest('.product-description');
        if (desc) {
          desc.querySelector('.small-description-js').classList.add('hide');
          desc.querySelector('.full-description-js').classList.remove('hide');
          desc.querySelector('.read-more-button-js').classList.add('hide');
        }
        return;
      }
      if (e.target.closest('.read-less-button-js')) {
        var desc = e.target.closest('.product-description');
        if (desc) {
          desc.querySelector('.small-description-js').classList.remove('hide');
          desc.querySelector('.full-description-js').classList.add('hide');
          desc.querySelector('.read-more-button-js').classList.remove('hide');
        }
        return;
      }
    });

    function initSwiperInPopup(popup) {
      var swiperEl = popup.querySelector('.quick-images-wrapper-js');
      if (!swiperEl || swiperEl.swiper) return;
      if (typeof Swiper === 'undefined') return;
      var paginationEl = swiperEl.querySelector('.swiper-pagination');
      var nextEl = swiperEl.querySelector('.swiper-button-next');
      var prevEl = swiperEl.querySelector('.swiper-button-prev');
      swiperEl.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false
      });
      if (swiperEl.swiper && typeof swiperEl.swiper.update === 'function') {
        swiperEl.swiper.update();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickViewPopup);
  } else {
    initQuickViewPopup();
  }
})();
